<template>
    <Spinner v-if="isLoading" />

    <div class="logindiv">
      <div class="logo">
        <img alt="logo" src="@/assets/logo-biomedica-laboratorija.png"  height="60">
      </div>
      <form novalidate @submit.prevent="handleSubmit(!v$.$invalid)">
        <div class="usernamediv">
          <div class="userpasspanel p-float-label p-input-icon-right">
              <i class="pi pi-envelope" />
              <InputText id="email" v-model="v$.username.$model" aria-describedby="email-error"/>
              <label for="email">{{ translated('username') }}*</label>
          </div>
                       
        </div>
  
  
        <div class="errordiv">
          <small v-if="error && isChanged==false">{{ error }}</small>         
        </div>
        
  
        <div class="submitbutton">
          <Button :label="translated('sendRequest')"  @click="handleSubmit(!v$.$invalid)" />          
        </div>
  
  
      </form>
        <Dialog class="forgotPasswordDialog" v-model:visible="openForgotPasswordModal" modal :header="translated('registration')" :style="{ width: '30vw' }" :breakpoints="{ '960px': '50vw', '641px': '100vw' }">
            <p>
            Na vašu e-mail adresu poslat je link za promenu lozinke. Klikom na link bićete u mogućnosti da promenite lozinku i pristupite svom nalogu.
            </p>
            <template #footer>
                <Button :label="translated('setpass')" icon="pi pi-check" @click="openForgotPasswordModal=false,redirectToLogin()" autofocus class="submitDialogbtn" />
            </template>
        </Dialog>
    </div>
  </template>
  
  <script>
  import { computed } from "vue";
  import store from "@/store";
  import { email, required } from "@vuelidate/validators";
  import { useVuelidate } from "@vuelidate/core";
  import router from "@/router";
  import Spinner from "@/components/Spinner.vue"
  
  export default {
      components: { Spinner },
      setup: () => ({ v$: useVuelidate() }),  
      data() {
          return {
              isLoading: false,
              username: '',
              password: '',
              submitted: false,
              isChanged: false,
              error: computed(() => store.state.error),
              translated: computed(() => store.getters.getTranslate),
              openForgotPasswordModal: false       
          }
      },
      validations() {
          return {
              username: {
                  required,
                  email
              }
          }
      },      
      created() { 
        // console.log('LOGIN !!!')
      },       
      methods: {
          createAccount() {
              router.push("register");
          },      
          async handleSubmit(isFormValid) {
            this.isChanged = false
              //// console.log('klicem submit:' + isFormValid)
              this.submitted = true;
  
              if (!isFormValid) {
                  return;
              }

              this.isLoading = true;

              debugger;
              //// console.log(model)
              await this.$store.dispatch("forgotPassword", this.username);
              if(this.$store.getters.getForgotPasswordResult){
                this.openForgotPasswordModal = true;
              }

              this.isLoading = false;
          },
          async changedInput() {
            this.isChanged = true
          },
          redirectToLogin() {
            router.push("login");
          }
      }
  }
  
  
  
  </script>
  
  <style scoped>
    .donthaveaccount {
        text-align: center;
        cursor: pointer;
    }
  
    form {
      background: white;
      padding: 20px;
      border-radius: 0 0 10px 10px;
    }
  
    form button {
      display: block;
      margin: 10px auto 0;
    }
  
    .logo img {display: block;margin-left: auto;margin-right: auto;}
  
    .logindiv .logo {
      background: #f2f2f2;
      padding:10px;
      padding-bottom: 40px;;
    }
  
  .userpasspanel {
      width: 100%;
  } 
  
  .usernamediv {
      margin-top: 30px;
  }
  
  .donthaveaccount {
      margin-top: 20px;
  }
  .p-dialog.p-component.forgotPasswordDialog .p-dialog-header .p-dialog-header-icons { display:none !important}

  .submitDialogbtn {
    position: relative;
    top: 50%;
  }
</style>
  